import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/sick-leaves/settings";

export default class SickLeaveSettingsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getSettings() {
		return http.get(apiEndpoint);
	}

	updateSettings(data) {
		return http.put(apiEndpoint, data);
	}
}
